export default __webpack_public_path__ + "assets/link_list_widget.16438af8225bd1d39d4ded2b3e97509c.svg";